module.exports = __webpack_public_path__ + "img/checkout-instructions-header.48e4c407.svg";